import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddNewUserDetailsComponent } from './add-new-user-details/add-new-user-details.component';
import { RouterConstants } from 'src/app/core/constants/router.constants';

const routes: Routes = [{ path: RouterConstants.addUserDetails, component: AddNewUserDetailsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewRegistrationRoutingModule { }
